import { createGlobalStyle, css } from 'styled-components'
import { BaseColor, borderRadius, Color, rem, spacing, themeColor } from '~theme'
import successIcon from '~assets/icons/circle_check.svg'
import errorIcon from '~assets/icons/circle_times.svg'
import warningIcon from '~assets/icons/exclamation_triangle.svg'
import infoIcon from '~assets/icons/circle_info.svg'

const prefixIcon = css`
  content: '';
  flex-shrink: 0;
  mask-size: cover;
  display: inline-block;
  width: ${rem(16)};
  height: ${rem(16)};
  margin-right: ${spacing(0.5)};
  background-color: currentColor;
`

const ToastStyles = createGlobalStyle`
  .Toastify__toast-container {
    width: ${rem(340)};
    max-width: 100%;

    .Toastify__toast {
      display: flex;
      align-items: center;
      min-height: ${rem(38)};
      border-radius: ${borderRadius};
      border: 1px solid ${themeColor(BaseColor.shade_30)};
      color: ${themeColor(BaseColor.shade_60)};
      padding: ${spacing(0.75)};
      background: ${themeColor(BaseColor.surfaceBg)};
      margin-bottom: ${spacing(0.75)};


      .Toastify__progress-bar--success {
        background: ${themeColor(Color.success)};
      }

      &.Toastify__toast--success::before {
        ${prefixIcon};
        mask: url(${successIcon}) no-repeat 50% 50%;
        color: ${themeColor(Color.success)};
      }

      &.Toastify__toast--success.permanent-toast {
        border: 1px solid ${themeColor(Color.success)};
        border-bottom-width: 4px;
      }

      .Toastify__progress-bar--warning {
        background: ${themeColor(Color.warning)};
      }

      &.Toastify__toast--warning::before {
        ${prefixIcon};
        mask: url(${warningIcon}) no-repeat 50% 50%;
        color: ${themeColor(Color.warning)};
      }

      &.Toastify__toast--warning.permanent-toast {
        border: 1px solid ${themeColor(Color.warning)};
        border-bottom-width: 4px;
      }

      .Toastify__progress-bar--info {
        background: ${themeColor(Color.primary)};
      }

      &.Toastify__toast--info::before {
        ${prefixIcon};
        mask: url(${infoIcon}) no-repeat 50% 50%;
        color: ${themeColor(Color.primary)};
      }

      &.Toastify__toast--info.permanent-toast {
        border: 1px solid ${themeColor(Color.primary)};
        border-bottom-width: 4px;
      }

      .Toastify__progress-bar--error {
        background: ${themeColor(Color.danger)};
      }

      &.Toastify__toast--error::before {
        ${prefixIcon};
        mask: url(${errorIcon}) no-repeat 50% 50%;
        color: ${themeColor(Color.danger)};
      }

      &.Toastify__toast--error.permanent-toast {
        border: 1px solid ${themeColor(Color.danger)};
        border-bottom-width: 4px;
      }

      .Toastify__toast-body {
        padding: 0;
        margin-right: ${rem(15)};
      }
    }
   &.Toastify__toast-container--top-center {
       top: ${rem(65)}
   }
  }
`

export default ToastStyles
